import React from "react";
import PropTypes from "prop-types";
import DateField from "../../common/DateField";
import { displayDate } from "../../common/datePresentation";

function PaymentSchedulePreview({
  items,
  onChange,
  onRemove,
  readOnly,
}) {
  return (
    <div className="table-responsive mt-3">
      <table className="table table-sm">
        <thead>
          <tr>
            <th>Termin</th>
            <th>Opis</th>
            <th>Kwota</th>
            <th>Status</th>
            {!readOnly && <th>Akcje</th>}
          </tr>
        </thead>
        <tbody>
          {items.map(item => (
            <tr key={item.id}>
              <td>
                {readOnly ? displayDate(item.dueDate) : (
                  <DateField
                    aria-label={`Termin platnosci ${item.description}`}
                    className="form-control form-control-sm"
                    type="date"
                    value={item.dueDate}
                    onChange={event => onChange(item.id, "dueDate", event.target.value)}
                  />
                )}
              </td>
              <td>
                {readOnly ? item.description : (
                  <input
                    aria-label={`Opis platnosci ${item.description}`}
                    className="form-control form-control-sm"
                    value={item.description}
                    onChange={event => onChange(item.id, "description", event.target.value)}
                  />
                )}
              </td>
              <td>
                {readOnly ? item.amount : (
                  <input
                    aria-label={`Kwota platnosci ${item.description}`}
                    className="form-control form-control-sm"
                    type="number"
                    value={item.amount}
                    onChange={event => onChange(item.id, "amount", Number(event.target.value || 0))}
                  />
                )}
              </td>
              <td>{item.status}</td>
              {!readOnly && (
                <td>
                  <button
                    type="button"
                    className="btn btn-sm manage-button manage-teal-button"
                    aria-label={`Usun platnosc ${item.description}`}
                    onClick={() => onRemove(item.id)}
                  >
                    Usun
                  </button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

PaymentSchedulePreview.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    dueDate: PropTypes.string.isRequired,
    description: PropTypes.string,
    amount: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired,
  })),
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  readOnly: PropTypes.bool,
};

PaymentSchedulePreview.defaultProps = {
  items: [],
  onChange: () => {},
  onRemove: () => {},
  readOnly: false,
};

export default PaymentSchedulePreview;
